//
// Game
//
// Plumbs components together once they have all loaded

game = {};
gameData = {};
gameData.gameName = 'Bank of Blarney Top Hit';
gameData.gameVersionMajor = '1';
gameData.gameVersionMinor = '0';
gameData.gameVersionBugFix = '5';
gameData.gameReleaseDate = '19/01/25'; // update me upon release

gameData.symbolWidth = 156;
gameData.symbolHeight = 156;
gameData.appertureSize = 156;
gameData.numReels = 5;
gameData.numRows = 3;

gameData.themeTuneId = undefined;
gameData.freespinsThemeTuneId = undefined;
gameData.mainTunePlaying = false;
game.sideMenuOpen = false;
gameData.encoreEnabled = false;
game.timeScale = 1;
game.tutorialClosed = false;

game.autoClickTimer = undefined;

gameData.convertStringToSegmentId = function (str) {
  switch (str) {
    case 'segmentGreen': {
      return gameData.segmentDollar;
    }
    case 'segmentYellow': {
      return gameData.segmentBigWin;
    }
    case 'segmentBlue': {
      return gameData.segmentBonus;
    }
    case 'segmentRed': {
      return gameData.segmentFreespins;
    }
    case 'fsSegmentMega': {
      return gameData.fsSegmentMega;
    }
    case 'fsSegmentSuper': {
      return gameData.fsSegmentSuper;
    }
    case 'fsSegmentMidi': {
      return gameData.fsSegmentMidi;
    }
    case 'fsSegmentMinor': {
      return gameData.fsSegmentMinor;
    }
    case 'fsSegmentMini': {
      return gameData.fsSegmentMini;
    }
    case 'fsSegment3Fs': {
      return gameData.fsSegment3Fs;
    }
    case 'fsSegment5Fs': {
      return gameData.fsSegment5Fs;
    }
    case 'fsSegment8Fs': {
      return gameData.fsSegment8Fs;
    }
    default: {
      console.log('');
    }
  }
};

game.autoplayPopupOpen = false;

game.splashScreenDone = false;

Reflex.enableDeveloperMode();
//Reflex.developerModeData.createTestLanguages = true;
//Reflex.developerModeData.highlightTranslatedText = true;

game.onCreditChanged = function (creditTask) {
  gameData.credit = creditTask.data.balance;
  gameData.creditMeter.set(creditTask.data.balance);
  gameData.topLayerCreditMeter.set(creditTask.data.balance);
};

game.createGameVersion = function () {
  var versionString =
    gameData.gameName +
    ' v' +
    gameData.gameVersionMajor +
    '.' +
    +gameData.gameVersionMinor +
    '.' +
    gameData.gameVersionBugFix;
  console.log(versionString);
};

game.initialise = function (gameConfigTask) {
  // --------------------------------------------------------------------------------------------
  // All game data has been loaded, initial layout has been set, and gameData has been populated.
  // Time to link everything together.
  // --------------------------------------------------------------------------------------------
  var i;

  // Create the game version text
  game.createGameVersion();

  gameData.gameConfig = gameConfigTask.data;

  // Set initial state
  resourceManager.getController('inputOverlord').setState('enabled');

  // Hide all screens except loading. These will be shown when loading continues
  resourceManager.getContainer('gameContainer').visible = false;
  resourceManager.getContainer('DemoContainer').visible = false;
  resourceManager.getContainer('gameButtonContainer').visible = false;
  // resourceManager.getContainer("specialButtonContainer").visible = false;

  gameData.stakes = [];
  gameData.coinSizes = [];
  gameData.currentStakeIndex = gameConfigTask.data.slotConfig.coinSizes.indexOf(
    gameConfigTask.data.slotConfig.defaultAmountPerLine
  );
  gameData.numLines = gameConfigTask.data.slotConfig.defaultNumLines;
  for (i = 0; i < gameConfigTask.data.slotConfig.coinSizes.length; i++) {
    gameData.stakes.push(gameConfigTask.data.slotConfig.coinSizes[i] * gameConfigTask.data.slotConfig.defaultNumLines);
    gameData.coinSizes.push(gameConfigTask.data.slotConfig.coinSizes[i]);
  }

  gameData.topLayerMeters = resourceManager.get('topLayerMeters');
  gameData.topLayerMeters.visible = false;
  gameData.stakeMeter = resourceManager.get('meterContainer:stake:meter');
  gameData.topLayerStakeMeter = resourceManager.get('topLayerMeters:stake:meter');
  gameData.creditMeter = resourceManager.get('meterContainer:credit:meter');
  gameData.topLayerCreditMeter = resourceManager.get('topLayerMeters:credit:meter');
  gameData.winningsMeter = resourceManager.get('meterContainer:winnings:meter');
  gameData.winningsMeterTitle = resourceManager.get('meterContainer:winnings:title');

  gameData.fishermanMeter0 = resourceManager.get('postReelsNudge:winnings:meter0');
  gameData.fishermanMeter0.visible = false;
  gameData.fishermanMeter1 = resourceManager.get('postReelsNudge:winnings:meter1');
  gameData.fishermanMeter1.visible = false;
  gameData.fishermanMeter2 = resourceManager.get('postReelsNudge:winnings:meter2');
  gameData.fishermanMeter2.visible = false;
  gameData.fishermanMeter3 = resourceManager.get('postReelsNudge:winnings:meter3');
  gameData.fishermanMeter3.visible = false;
  gameData.fishermanMeter4 = resourceManager.get('postReelsNudge:winnings:meter4');
  gameData.fishermanMeter4.visible = false;

  gameData.multiplierValues = [2, 3, 4, 5, 10, 20, 50, 100];

  messageBus.subscribe('common:BalanceEvent', game.onCreditChanged);
  messageBus.subscribe('game:modal', game.modal);
  messageBus.subscribe('game:sideMenuOpen', game.sideMenuOpenMsg);
  messageBus.subscribe('game:sideMenuClosed', game.sideMenuClosedMsg);
  Reflex.registerEventHandler('orientationChange', game.onOrientationChange);
  Reflex.registerEventHandler('resize', game.onResize);

  gameController.initialise(gameConfigTask);

  if (gameData.recoveryStake) {
    game.changeStake(gameData.recoveryStake);
  } else {
    game.changeStake(gameData.stakes[gameData.currentStakeIndex]);
  }

  if (gameData.encoreEnabled) {
    var encoreButtonLB = resourceManager.get('buttonContainer:buttonBar:luckyBetToggleButton');
    encoreButtonLB.setRecovery(true);
    encoreButtonLB.showButton();
  }

  // Kick off the game
  game.onOrientationChange();
  gameController.start();

  messageBus.subscribe('game:backFromReplay', backFromReplay);
};

function backFromReplay(data) {
  if (
    soundManager.sharedMode === true // we have been sharing the soundManager
  ) {
    // im going to assume the back button has been pressed during watching a replay
    // the ygg platform is telling us to unmute audio
    // stop any sounds currently playing from the old replay game
    // then clear the sharedMode flag
    // we need to restore what audio and what levels they were playing at
    // this think this will be down to each client to handle this as ids are stored all over the place
    // the music managers are inconsistant
    soundManager.stopAllSounds();
    soundManager.sharedMode = false;
    messageBus.post('sounds:restorePreviouslyPlayingAudio', {
      reason: 'back from replay',
    });
  }
}

game.enableSpeedUp = function () {
  const caller = new Error().stack?.split('\n')[2]?.trim().split(' ')[1];
  if (caller === 'GDK.readyCb') {
    document.addEventListener('keydown', (event) => {
      let validOptionPressed = true;
      if (event.key === '*') {
        game.timeScale += 0.05;
      } else if (event.key === '/') {
        game.timeScale -= 0.05;
      } else if (event.key === '-') {
        game.timeScale = 1;
      } else if (event.key === '0') {
        game.timeScale = 0;
      } else if (event.key === '1') {
        game.timeScale = 0.2;
      } else if (event.key === '2') {
        game.timeScale = 0.4;
      } else if (event.key === '3') {
        game.timeScale = 0.6;
      } else if (event.key === '4') {
        game.timeScale = 0.8;
      } else if (event.key === '5') {
        game.timeScale = 1;
      } else if (event.key === '6') {
        game.timeScale = 1.5;
      } else if (event.key === '7') {
        game.timeScale = 2;
      } else if (event.key === '8') {
        game.timeScale = 3;
      } else if (event.key === '9') {
        game.timeScale = 5;
      } else {
        validOptionPressed = false;
      }

      if (validOptionPressed) {
        if (game.timeScale > 10) game.timeScale = 10;
        if (game.timeScale < 0) game.timeScale = 0;

        console.log('Time scale: ' + game.timeScale.toFixed(2));

        // not sure this bit is needed
        if (Reflex.gamePaused || Reflex.platformPaused) {
          soundManager.pauseAllSounds();
        } else {
          soundManager.resumeAllSounds();
        }
        ///////
        soundManager.setTimeScale(game.timeScale);
        gsap.globalTimeline.timeScale(game.timeScale);
        Reflex.setGameSpeed(game.timeScale);
      }
    });
  }
};

game.sideMenuOpenMsg = function () {
  game.sideMenuOpen = true;
};

game.sideMenuClosedMsg = function () {
  game.sideMenuOpen = false;
};

game.onResize = function () {
  if (gameData.gameMask) {
    if (systemData.isLandscape) {
      gameData.gameMask.scale.x = 1280;
      gameData.gameMask.scale.y = 720;
    } else {
      gameData.gameMask.scale.x = 720;
      gameData.gameMask.scale.y = 1280;
    }
  }
};

game.onOrientationChange = function () {
  if (game.slideShowActive) {
    game.updateSplashScreen();
  }

  if (game.splashScreenDone) {
    switch (layoutController.getCurrentLayout()) {
      case 'landscape_default':
      case 'landscape_mobile': {
        resourceManager.getContainer('backgroundContainer').visible = true;
        resourceManager.getContainer('backgroundContainerPortrait').visible = false;
        break;
      }
      case 'portrait_default':
      case 'portrait_mobile': {
        resourceManager.getContainer('backgroundContainer').visible = false;
        resourceManager.getContainer('backgroundContainerPortrait').visible = true;
        break;
      }
    }
  }
};

game.disableSplashBackgrounds = function (background, portrait_background) {
  background.visible = false;
  background.interactive = false;
  background.on('mouseup', function () {});
  background.on('touchend', function () {});
  portrait_background.visible = false;
  portrait_background.interactive = false;
  portrait_background.on('mouseup', function () {});
  portrait_background.on('touchend', function () {});
};

game.onCloseTutorial = function () {
  game.stopAutoClickForReplayRewatch();

  if (game.tutorialClosed) {
    return;
  }

  game.tutorialClosed = true;

  const bgContainer = resourceManager.getContainer('backgroundContainer');
  bgContainer.visible = true;
  gameData.gameMask = new PIXI.Graphics();
  gameData.gameMask.beginFill(0xffffff);
  gameData.gameMask.lineStyle(0, 0xffffff);
  gameData.gameMask.drawRect(0, 0, 1, 1);
  bgContainer.addChild(gameData.gameMask);

  systemData.gameContainer.mask = gameData.gameMask;

  helper.updateHelpWinlineText();

  game.goToGame();
};

game.autoClickForReplayRewatchTimer = function (cb, time = 4000) {
  if (gdk.serverParser._inReplayMode || gdk.serverParser._inRewatchMode) {
    game.stopAutoClickForReplayRewatch();
    game.autoClickTimer = timerManager.addTimeout(time, cb);
  }
};

game.stopAutoClickForReplayRewatch = function () {
  if (game.autoClickTimer) {
    timerManager.stop(game.autoClickTimer);
    game.autoClickTimer = undefined;
  }
};

game.goToSplash = function () {
  var loadingData = gdk.getPlatformLoadingData();
};

game.goToGame = function () {
  if (gdk.deviceInfo.chrome) {
    var chromeVersion = Number(
      String(gdk.deviceInfo.version).substring(0, String(gdk.deviceInfo.version).indexOf('.'))
    );
    if (chromeVersion >= 55) {
      // Chrome will only start audio on a touch
      Howler.ctx.resume();
    }
  }

  game.slideShowActive = false;

  timerManager.stop(game.slideshowTimer);

  gameData.mainTunePlaying = true;

  resourceManager.getContainer('loadingContainer').visible = false;
  resourceManager.getContainer('gameContainer').visible = true;
  resourceManager.getContainer('msgBoxPopupContainer').visible = true;
  resourceManager.getContainer('gameButtonContainer').visible = true;
  resourceManager.getContainer('particleContainer').visible = true;
  resourceManager.getContainer('buyABonusContainer').visible = true;
  resourceManager.getContainer('settingsMenuContainer').visible = true;
  resourceManager.getContainer('florishContainer').visible = true;
  resourceManager.getContainer('splashContainer').visible = false;
  resourceManager.getContainer('loadingContainer').visible = false;
  resourceManager.get('maxWinPopup').visible = false;
  resourceManager.getContainer('helpPageScrollContainer').visible = true;

  gameData.helpPageScroll = resourceManager.get('helpPageScrollContainer:helpPageScroll');
  gameData.winningsText = resourceManager.get('winningsText');
  game.loadingBackgroundLandscape = resourceManager.get('splashBackgroundL');
  game.loadingBackgroundLandscape.clearInteractiveCallbacks();
  game.loadingBackgroundPortrait = resourceManager.get('splashBackgroundP');
  game.loadingBackgroundPortrait.clearInteractiveCallbacks();

  resourceManager.getContainer('DemoContainer').visible = true;

  game.onResize();

  game.onOrientationChange();

  if (gameData.license === '' || gameData.license === undefined) {
    gameData.license = 'default';
  }

  let license = gameData.license.toUpperCase();

  if (license === 'BR') {
    resourceManager.get('helpPageScrollContainer:helpPageScroll').open();
  }

  //game.overrideButtons();
  if (!Reflex.developerMode && gdk.deviceInfo.mobile && !gdk.isFullscreen()) {
    gdk.requestFullscreen();
  }

  if (gameController.inRecovery) {
    gameController.initNewGame();
  }
};

game.overrideButtons = function () {
  game.addNonNumpadSpeedControl();

  const uiName = 'uiContainer:bg';

  // const slamStopButton = resourceManager.get(uiName + ":slamStopButton");
  // slamStopButton.canEnableBase = slamStopButton.canEnable;
  // slamStopButton.canEnable = function(){
  //     return slamStopButton.canEnableBase() && !gameController.spinComplete && gameData.reelsSpinning > 0 && gameController.canSlamStop;
  // };
  // const slamStopButtonPortrait = resourceManager.get("buttonContainerMobile:reflexButtonBar:slamStopButton_portrait");
  // slamStopButtonPortrait.canEnableBase = slamStopButtonPortrait.canEnable;
  // slamStopButtonPortrait.canEnable = function(){
  //     return slamStopButtonPortrait.canEnableBase() && !gameController.spinComplete && gameData.reelsSpinning > 0 && gameController.canSlamStop;
  // };

  const autoplayController = resourceManager.getController('autoplayController');

  const baseStart = autoplayController.start;
  const baseCancel = autoplayController.cancel;

  autoplayController.start = function () {
    soundManager.play('buttonPressed');
    baseStart();
  };

  autoplayController.cancel = function () {
    if (game.autoplayPopupOpen) {
      soundManager.play('buttonPressed');
    }
    baseCancel();
  };

  const spinButton = resourceManager.get('uiContainer:bg:spinButton');
  spinButton.canEnableBase = spinButton.canEnable;
  spinButton.canEnable = function () {
    return (
      this.canEnableBase() &&
      /*!settingsMenu.container.visible &&*/ !helpPageManager.container.visible &&
      !game.sideMenuOpen
    );
  };
  const spinButtonPortrait = resourceManager.get('buttonContainerMobile:reflexButtonBar:spinButton_portrait');
  spinButtonPortrait.canEnableBase = spinButtonPortrait.canEnable;
  spinButtonPortrait.canEnable = function () {
    return (
      this.canEnableBase() &&
      /*!settingsMenu.container.visible &&*/ !helpPageManager.container.visible &&
      !game.sideMenuOpen
    );
  };

  const autoplayButton = resourceManager.get('uiContainer:bg:autoplayButton');
  autoplayButton.baseCanEnable = autoplayButton.canEnable;
  autoplayButton.canEnable = function () {
    return this.baseCanEnable() && !game.sideMenuOpen;
  };
  const autoplayButtonPortrait = resourceManager.get('buttonContainerMobile:reflexButtonBar:autoplayButton_portrait');
  autoplayButtonPortrait.baseCanEnable = autoplayButtonPortrait.canEnable;
  autoplayButtonPortrait.canEnable = function () {
    return this.baseCanEnable() && !game.sideMenuOpen;
  };

  const stakeButton = resourceManager.get('uiContainer:bg:stake');
  stakeButton.baseCanEnable = stakeButton.canEnable;
  stakeButton.canEnable = function () {
    return this.baseCanEnable() && !game.sideMenuOpen;
  };
  const stakeButtonPortrait = resourceManager.get('buttonContainerMobile:reflexButtonBar:stake_portrait');
  stakeButtonPortrait.baseCanEnable = stakeButtonPortrait.canEnable;
  stakeButtonPortrait.canEnable = function () {
    return this.baseCanEnable() && !game.sideMenuOpen;
  };

  const volumeButton = resourceManager.get('uiContainer:bg:volume');
  volumeButton.baseCanEnable = volumeButton.canEnable;
  volumeButton.canEnable = function () {
    return this.baseCanEnable() && !game.sideMenuOpen;
  };
};

game.modal = function (task) {
  if (task.reason === 'autoplay') {
    game.autoplayPopupOpen = true;
  } else if (task.reason === undefined || task.reason === '') {
    game.autoplayPopupOpen = false;
  }
};

game.addNonNumpadSpeedControl = function () {
  if (gdk.isDevelopmentBuild()) {
    Reflex.developerModeData.keyDownCallbacks.push(function (keycode) {
      if (!Reflex.developerModeData.manipulateCredit) {
        switch (keycode) {
          case 32: {
            // Pause/break key
            Reflex.gamePaused = !Reflex.gamePaused;
            break;
          }
          case 48: {
            // Keypad 0
            Reflex.gamePaused = !Reflex.gamePaused;
            break;
          }
          case 49: {
            // Keypad 1
            Reflex.developerModeData.speedModifier = 0.0625;
            break;
          }
          case 50: {
            // Keypad 2
            Reflex.developerModeData.speedModifier = 0.125;
            break;
          }
          case 51: {
            // Keypad 3
            Reflex.developerModeData.speedModifier = 0.25;
            break;
          }
          case 52: {
            // Keypad 4
            Reflex.developerModeData.speedModifier = 0.5;
            break;
          }
          case 53: {
            // Keypad 5
            Reflex.developerModeData.speedModifier = 1.0;
            break;
          }
          case 54: {
            // Keypad 6
            Reflex.developerModeData.speedModifier = 2.0;
            break;
          }
          case 55: {
            // Keypad 7
            Reflex.developerModeData.speedModifier = 4.0;
            break;
          }
          case 56: {
            // Keypad 8
            Reflex.developerModeData.speedModifier = 8.0;
            break;
          }
          case 57: {
            // Keypad 9
            Reflex.developerModeData.speedModifier = 16.0;
            break;
          }
          case 58: {
            // * key
            Reflex.developerModeData.speedModifier += 0.05;
            break;
          }
          case 59: {
            // / Key
            Reflex.developerModeData.speedModifier -= 0.05;
            break;
          }
          default:
            break;
        }

        if (Reflex.developerModeData.speedModifier > 256) Reflex.developerModeData.speedModifier = 256;
        if (Reflex.developerModeData.speedModifier < 0.00390625) Reflex.developerModeData.speedModifier = 0.00390625;

        if (Reflex.gamePaused || Reflex.platformPaused) {
          soundManager.pauseAllSounds();
        } else {
          soundManager.resumeAllSounds();
        }
        soundManager.setTimeScale(Reflex.developerModeData.speedModifier);
        PIXI.ticker.shared.speed = Reflex.developerModeData.speedModifier;
      }
    });
  }
};

game.changeStake = function (stake) {
  if (stake !== undefined) {
    gameData.stakeMeter.set(stake);
    gameData.topLayerStakeMeter.set(stake);
    gdk.playerChangedStake(stake);
  }
};

game.onHelpPagesClosed = function () {};

game.onOptionsButtonPressed = function () {
  helpPageManager.showPopup(game.onHelpPagesClosed);
};

game.onAutoplayDialogCancelled = function () {};

game.onAutoplayDialogConfirmed = function () {
  gameController.startAutoplay();
};

game.onAutoplayButtonPressed = function () {
  // If autoplay is running, cancel
  if (autoplayManager.isAutoplayEnabled()) {
    if (gameController.state === 'WAITING_FOR_AUTOPLAY') {
      soundManager.play(gameData.sounds.autoplayCancel);
    } else {
      // We are autoplaying, so wait for autoplay to complete before enabling buttons
      gameData.autoplayButton.enableButton(false);
    }

    autoplayManager.stopAutoplay();
    gameController.cancelAutoplay();

    return;
  }

  // If we are in a waiting state, pop up the auto play interface
  if (gameController.state === 'WAITING_FOR_START') {
    soundManager.play(gameData.sounds.autoplayPress);
    autoplayManager.openDialog(
      game.onAutoplayDialogConfirmed,
      game.onAutoplayDialogCancelled,
      gameData.coinSizes[gameData.currentStakeIndex],
      20
    );
  }
};

//
// Overide of the ReflexLoader.startLoading function to add a random cache query string to resource requests
ReflexLoader.startLoading = function (filesList, ID, progressCallback, completeCallback) {
  var loader = new PIXI.loaders.Loader();
  var filesToLoad = 0;
  var i;
  var atlasName;

  // Set the default query string using the random string and version info
  loader.defaultQueryString =
    'v=' + gameData.gameVersionMajor + '.' + gameData.gameVersionMinor + '.' + gameData.gameVersionBugFix;

  for (i = 0; i < filesList.length; ++i) {
    if (!filesList[i]) continue;

    // If developer has forgot to put rootRes on, then we add it
    switch (typeof filesList[i]) {
      case 'string':
        {
          if (filesList[i].indexOf(ReflexLoader.rootResDir) === -1) {
            filesList[i] = ReflexLoader.rootResDir + filesList[i];
          }
        }
        break;

      case 'object': {
        if (filesList[i].file.indexOf(ReflexLoader.rootResDir) === -1) {
          filesList[i].file = ReflexLoader.rootResDir + filesList[i].file;
        }
      }
    }

    var lower = filesList[i];
    atlasName = ReflexLoader.fileAtlasData[lower];

    if (!atlasName) {
      // file not atlased
      if (typeof lower === 'object') {
        if (checkForUndefined(loader.resources[lower.file] && checkForUndefined(PIXI.utils.TextureCache[lower.file]))) {
          let filename = gdk.ammendResourceName(lower.file);
          let metadata = {};

          // if it is a spine object we need to give it its meta data due to new crc requirements.
          // otherwise the atlas filename it tries to load will be the same as the json filename, but
          // it wont match due to the crc being different
          if (lower.isSpine) {
            metadata = ReflexLoader.createSpineMetadata(lower.file);
          }

          loader.add(lower.name, filename, {
            crossOrigin: 'use-credentials',
            metadata: metadata,
          });
          filesToLoad++;
        }
      } else {
        if (checkForUndefined(loader.resources[lower]) && checkForUndefined(PIXI.utils.TextureCache[lower])) {
          let filename = gdk.ammendResourceName(lower);

          loader.add(lower, filename, { crossOrigin: 'use-credentials' });
          filesToLoad++;
        }
      }
    } else {
      // file in an atlase, but is atlas loaded?
      if (!ReflexLoader.atlasesLoaded[atlasName].loaded) {
        // not loaded so add it to loader
        ReflexLoader.atlasesLoaded[atlasName].loaded = true;

        loader.add(atlasName, { crossOrigin: 'use-credentials' });
        filesToLoad++;
      }
    }
  }

  ReflexLoader.currentID = ID;
  ReflexLoader.progressCallback = progressCallback;
  ReflexLoader.completeCallback = completeCallback;

  loader.on('progress', ReflexLoader.onAssetsLoadProgress);
  loader.on('error', ReflexLoader.onLoadError);
  loader.once('complete', ReflexLoader.onAssetsLoadComplete);
  loader.load();

  return filesToLoad;
};

ReflexLoader.loadAtlasDataFiles = function (atlasList, completeCallback) {
  const fileVersionString =
    '?v=' + gameData.gameVersionMajor + '.' + gameData.gameVersionMinor + '.' + gameData.gameVersionBugFix;

  var loadFunc = function (i) {
    if (i < atlasList.length) {
      ReflexLoader.atlasesLoaded[atlasList[i]] = { loaded: false };

      $.getJSON(atlasList[i] + fileVersionString, function (json) {
        for (var j in json.frames) {
          if (json.frames.hasOwnProperty(j)) {
            if (ReflexLoader.fileAtlasData[j]) {
              alert('filename ' + j + ' already exists in atlas ' + ReflexLoader.fileAtlasData[j]);
            }
            ReflexLoader.fileAtlasData[j] = atlasList[i];
          }
        }
        loadFunc(i + 1);
      }).fail(function (jqxhr, status, error) {
        console.error('Failed to load Atlas file ' + atlasList[i]);
        console.error(error.message);
      });
    } else {
      completeCallback();
    }
  };

  if (atlasList.length === 0) {
    // No atlas files to load
    completeCallback();
  } else {
    // Start loading atlas files
    loadFunc(0);
  }
};

resourceManager.onLoadCompleteBase = resourceManager.onLoadComplete;
resourceManager.onLoadComplete = function () {
  Loader.loadMask.scale.x = 1;
  resourceManager.isLoaded = true; // so timer is running
  timerManager.addTimeout(1000, () => {
    resourceManager.onLoadCompleteBase(1);
  });
};
